import type { OrdersStore } from './interfaces'

export const actions = {
  setLoading (this: OrdersStore, payload: OrdersStore['loading']): void {
    this.loading = payload
  },
  setOrders (this: OrdersStore, payload: OrdersStore['orders']): void {
    this.orders = payload
  },
  setMeta (this: OrdersStore, payload: OrdersStore['meta']): void {
    this.meta = payload
  },
  setFilterSearch (this: OrdersStore, payload: OrdersStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterStatuses (this: OrdersStore, payload: OrdersStore['filterStatuses']): void {
    this.filterStatuses = payload
  },
  setFilterType (this: OrdersStore, payload: OrdersStore['filterType']): void {
    this.filterType = payload
  },
  setFilterFrom (this: OrdersStore, payload: OrdersStore['filterFrom']): void {
    this.filterFrom = payload
  },
  setFilterTo (this: OrdersStore, payload: OrdersStore['filterTo']): void {
    this.filterTo = payload
  },
  setFilterLessonsFrom (this: OrdersStore, payload: OrdersStore['filterLessonsFrom']): void {
    this.filterLessonsFrom = payload
  },
  setFilterLessonsTo (this: OrdersStore, payload: OrdersStore['filterLessonsTo']): void {
    this.filterLessonsTo = payload
  },
  setFilterPromocodeId (this: OrdersStore, payload: OrdersStore['filterPromocodeId']): void {
    this.filterPromocodeId = payload
  },
  setFilterCustomerId (this: OrdersStore, payload: OrdersStore['filterCustomerId']): void {
    this.filterCustomerId = payload
  },
  setCurrentPage (this: OrdersStore, payload: OrdersStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: OrdersStore, payload: OrdersStore['perPage']): void {
    this.perPage = payload
  },
  resetFilters (this: OrdersStore): void {
    this.filterSearch = null
    this.filterStatuses = []
    this.filterType = null
    this.filterFrom = null
    this.filterTo = null
    this.filterLessonsFrom = null
    this.filterLessonsTo = null
    this.filterPromocodeId = null
    this.filterCustomerId = null
    this.currentPage = 1
  },
}
